module.exports = __webpack_public_path__ + "static/halalitalia-78b15224cf7f8e30202c13c349a38b14.png";